import { createHashRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import Root from "./Root";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import Datasets from "./pages/datasets/Datasets";
import UsersList from "./pages/users/UsersList";
import DynamicFormController from "./pages/datasets/DynamicFormController.react";
import ResetPassword from "./pages/reset-password/ResetPassword";
import SetupList from "./pages/setup/SetupList";

export const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },

      {
        element: <ProtectedRoute role={"EXECUTIVE"} />,
        children: [
          {
            path: "/dashboard",
            element: <Dashboard />,
          },
          {
            path: "/datasets",
            element: <Datasets />,
          },
          {
            path: "/users-list",
            element: <UsersList />,
          },
          {
            path: "/setup",
            element: <SetupList />,
          },
          {
            path: "/reset-password",
            element: <ResetPassword />,
          },
        ],
      },
      {
        path: "*",
        element: <p>404 - Error: Page not found</p>,
      },
    ],
  },
]);
